import NotificationListComponent from 'src/components/features/superAdmin/notificationListComponent';

const ListNotificationPage = () => <NotificationListComponent />;

export default ListNotificationPage;
